<template>
    <div
        class="w-full h-full mx-auto"
        style="background: #E6F2F3;"
    >
        <div class="h-full max-w-7xl mx-auto pb-20">
            <div class="mx-16 2xl:mx-0">
                <div class="w-full h-full pb-20">
                    <div class="flex mb-10 pt-10">
                        <h1 class="text-3xl">
                            Spisesteder
                        </h1>
                    </div>
                    <div class="w-full h-full">
                        <div class="w-full h-full flex flex-col justify-center items-center">
                            <svg width="39" height="30" viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 17H25.5H13.5ZM19.5 11V23V11ZM1.5 25V5C1.5 3.93913 1.92143 2.92172 2.67157 2.17157C3.42172 1.42143 4.43913 1 5.5 1H17.5L21.5 5H33.5C34.5609 5 35.5783 5.42143 36.3284 6.17157C37.0786 6.92172 37.5 7.93913 37.5 9V25C37.5 26.0609 37.0786 27.0783 36.3284 27.8284C35.5783 28.5786 34.5609 29 33.5 29H5.5C4.43913 29 3.42172 28.5786 2.67157 27.8284C1.92143 27.0783 1.5 26.0609 1.5 25Z" stroke="#8E87C7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p class="mt-6 font-semibold">Add eatery</p>
                            <p class="text-gray-600">Get Started by choosing a restaurant, café etc.</p>
                            <button
                                @click="showModal = true"
                                type="button"
                                class="mt-10 bg-primary-dark text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
                            >
                                + Choose from list
                            </button>
                        </div>
                        <div class="w-full rounded-lg grid grid-cols-2 gap-x-4 gap-y-4">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ActivityModal
        :show="showModal"
        title="Event details"
        @close="cancel"
        :size="`max-w-6xl`"
    >
        <div class="w-full h-full flex">
            <div class="w-1/2 flex flex-col pt-6 px-6">
                <div class="mt-4 w-full items-center">
                    <h2 class="text-lg font-semibold">Add {{ form.class }}</h2>
                    <p class="text-sm text-gray-500">Choose from the most popular, search or choose from the list</p>
                    <input type="search" placeholder="Search" class="my-6 border border-gray-300 rounded-md"/>
                </div>
                <p class="text-sm text-gray-500 mb-2">Local DB</p>
                <div class="w-full max-h-44 space-y-3 overflow-y-auto mb-2">
                    <ul v-for="local in localDB"  class="w-full flex flex-col">
                        <li class="w-full shadow-md rounded-md flex flex-row items-center justify-between hover:border hover:border-primary-dark">
                            <figure class="overflow-hidden w-20">
                                <img
                                    :src="local.img"
                                    class="object-cover rounded-l-lg"
                                />
                            </figure>
                            <p class="ml-3 w-full font-semibold text-left">{{ local.place }}</p>
                            <span class="mr-8">
                                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.4802 1.40271L13.1815 4.10408M13.1815 4.10408L10.4802 6.80544M13.1815 4.10408L1.02539 4.10407" stroke="#111827" stroke-width="1.35068" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            </span>
                        </li>
                    </ul>
                </div>
                <p class="text-sm text-gray-500 mb-2">Other</p>
                <div class="w-full max-h-40 space-y-2 overflow-y-auto">
                    <ul v-for="other in otherDB"  class="w-full flex flex-col gap-y-4">
                        <li class="w-full shadow-md rounded-md flex flex-row items-center justify-between hover:border hover:border-primary-dark">
                            <figure class="overflow-hidden w-20">
                                <img
                                    :src="other.img"
                                    class="object-cover rounded-l-lg"
                                />
                            </figure>
                            <p class="ml-3 w-full font-semibold text-left">{{ other.place }}</p>
                            <span class="mr-8">
                                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.4802 1.40271L13.1815 4.10408M13.1815 4.10408L10.4802 6.80544M13.1815 4.10408L1.02539 4.10407" stroke="#111827" stroke-width="1.35068" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="w-1/2 h-full bg-gray-100 p-6 rounded-r-lg">
                <div class="w-full h-full bg-white rounded-lg">
                    <figure class="relative overflow-hidden aspect-w-16 aspect-h-8">
                        <img
                            src="https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg"
                            class="object-cover rounded-t-lg"
                        />
                    </figure>
                    <div class="w-full p-6">
                        <h2 class="mb-4 text-xl font-semibold">Angelo Terra d'Italia</h2>
                        <p class="text-sm text-gray-700">Tre retters middag lorem ipsum dolor sit am et, consectetur adipiscing elit, sed do eius mod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
                    </div>
                </div>
                <div class="mt-6 mb-10 w-full h-full flex justify-end">
                    <button @click="cancel" type="button" class="bg-warning p-1 rounded-lg text-gray-100 mr-4">Cancel</button>
                    <button @click="cancel" type="button" class="bg-primary-dark text-white py-1 px-2 rounded-lg">Choose</button>
                </div>
            </div>
        </div>

    </ActivityModal>
</template>

<script setup>
import {ref} from "vue";
import ActivityModal from '../Modal/CalendarModal'
import {useForm} from "@inertiajs/vue3";

const showModal = ref(false)

const localDB = [
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
]

const otherDB = [
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
    {
        img: 'https://media-cdn.tripadvisor.com/media/photo-m/1280/21/c2/10/af/angelo-terra-d-italia.jpg',
        place: "Angelo Terra d'Italia"
    },
]

const form = useForm({
    start: null,
    end: null,
    title: '',
    content: '',
    class: ''
})

function cancel() {
    form.reset()
    showModal.value = false
}

</script>
